import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Ambient } from '../Ambient';
import { VexuMark } from '../Brand';
interface TalabLockupProps {
  variant?: 'bar' | 'hero';
}

/** TALAB — by Vexu AI. The attribution never appears without the parent brand. */
export function TalabLockup({
  variant = 'bar'
}: TalabLockupProps) {
  if (variant === 'hero') {
    return <div data-id="element-763" data-mp="ulaz5qzqm2gs">
        <div className="text-[44px] font-semibold leading-none tracking-[0.24em] text-slate-900" data-id="element-764" data-mp="18ihibmodi36j">
          TALAB
        </div>
        <div className="mt-[14px] flex items-center gap-[9px]" data-id="element-765" data-mp="14g30n5wfx9gu">
          <VexuMark size={20} data-id="element-766" data-mp="1i8j4g8x61bit" />
          <span className="text-[13px] font-medium tracking-[0.16em] text-slate-500" data-id="element-767" data-mp="1i7hivaiix6mu">
            by Vexu AI
          </span>
        </div>
      </div>;
  }
  return <div className="flex items-center gap-[14px]" data-id="element-768" data-mp="1s6gtuzqrhed0">
      <span className="text-[15px] font-semibold tracking-[0.26em] text-slate-900" data-id="element-769" data-mp="1s78czb369jme">
        TALAB
      </span>
      <span className="h-[13px] w-px bg-slate-300" data-id="element-770" data-mp="1n9gn0mm387ku" />
      <span className="flex items-center gap-[7px]" data-id="element-771" data-mp="v7b83nzn5vo8">
        <VexuMark size={16} data-id="element-772" data-mp="v8me7ugk7fii" />
        <span className="text-[11px] font-medium tracking-[0.14em] text-slate-500" data-id="element-773" data-mp="105cou29lhiwj">
          by Vexu AI
        </span>
      </span>
    </div>;
}
interface TalabChapterFrameProps {
  onExit: () => void;
  showLockup?: boolean;
  children: React.ReactNode;
}
export function TalabChapterFrame({
  onExit,
  showLockup = true,
  children
}: TalabChapterFrameProps) {
  return <section className="relative h-full w-full" data-id="element-774" data-mp="1e3kt6v8ynmhq">
      <Ambient variant="quiet" data-id="element-775" data-mp="1j3gps9fbwbn9" />

      <div className="relative flex h-full flex-col px-[80px] pb-[84px] pt-[40px]" data-id="element-776" data-mp="1j2dxbx2cy158">
        <div className="flex items-center justify-between" data-id="element-777" data-mp="1nvql64z7q3wx">
          <button type="button" onClick={onExit} className="group flex items-center gap-[9px] rounded-full border border-slate-900/[0.09] bg-white/70 px-[16px] py-[8px] text-[12px] font-medium text-slate-600 transition-colors duration-200 ease-out hover:border-vexu/45 hover:text-slate-900" data-id="element-778" data-mp="1rxbwhlw3ma50">
            <ArrowLeft className="h-[14px] w-[14px] text-vexu-600 transition-transform duration-200 ease-out group-hover:-translate-x-[2px]" data-id="element-779" data-mp="1t0628g2vg8c" />
            Vexu Ecosystem
          </button>

          {showLockup && <TalabLockup data-id="element-780" data-mp="bjuv1kkpktxh" />}
        </div>

        <div className="mt-[26px] flex min-h-0 flex-1 flex-col" data-id="element-781" data-mp="6s3bvv3vtqhd">{children}</div>
      </div>
    </section>;
}